import { useRequest } from 'ahooks';
import { isEmpty } from 'lodash-es';
import { getOccupation } from '@home/services/login';

export const useGetOccupation = () => {
  const data = useRequest(
    getOccupation,
    {
      cacheKey: 'loginOccupation',
      staleTime: 300000,
    },
  );
  return {
    ...data,
  };
};

export function transformDataToTree(data: any[], isEn: boolean) {
  if (isEmpty(data) || !Array.isArray(data)) return [];
  // 获取所有一级节点（parent_uid为空的）
  const topLevelNodes = data?.filter((item) => !item.parent_uid);

  // 创建树结构
  return topLevelNodes?.map((topNode) => {
    // 查找当前一级节点的所有子节点
    const children = data
      ?.filter((item) => item.parent_uid === topNode.uid)
      ?.map((child) => ({
        label: isEn ? child?.name : child.name_cn, // 使用中文名作为显示
        value: child.uid, // 使用uid作为值
      }));

    return {
      label: isEn ? topNode?.name : topNode.name_cn, // 一级节点中文名
      value: topNode.uid, // 一级节点uid
      children: children.length > 0 ? children : undefined, // 有子节点才包含children
    };
  });
}
